import axios from 'axios';
import {downloadFile, downloadFileServlet} from "../../utils/file/download";

export class ReportsService {
    getDailyReport(dataReport) {
        return axios.get('/appapv/getDailyReport.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                chkGarantia: dataReport.guaranteeCheck,
                fecValor: dataReport.dateCheck ? 1 : 0,
            }
        }).then(res => res.data);
    }

    getGuaranteeActiveDetailReport(dataReport) {
        return axios.get('/appapv/getGuaranteeActiveDetailReport.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                fechaInicial: dataReport.startDate.getFullYear() + "-" +
                    (dataReport.startDate.getMonth() + 1) + "-" +
                    dataReport.startDate.getDate(),
                fechaFinal: dataReport.finalDate.getFullYear() + "-" +
                    (dataReport.finalDate.getMonth() + 1) + "-" +
                    dataReport.finalDate.getDate(),
                chkGarantia: dataReport.guaranteeCheck,
                chkISIN: dataReport.isinColumn,
            }
        }).then(res => res.data);
    }

    getHistoricalReport(dataReport) {
        return axios.get('/appapv/getHistoricalReport.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                fechaInicial: dataReport.startDate.getFullYear() + "-" +
                    (dataReport.startDate.getMonth() + 1) + "-" +
                    dataReport.startDate.getDate(),
                fechaFinal: dataReport.finalDate.getFullYear() + "-" +
                    (dataReport.finalDate.getMonth() + 1) + "-" +
                    dataReport.finalDate.getDate(),
                chkGarantia: dataReport.guaranteeCheck,
            }
        }).then(res => res.data);
    }

    getActiveLoansReport(dataReport) {
        return axios.get('/appapv/getActiveReport.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                fechaInicial: dataReport.startDate.getFullYear() + "-" +
                    (dataReport.startDate.getMonth() + 1) + "-" +
                    dataReport.startDate.getDate(),
                fechaFinal: dataReport.finalDate.getFullYear() + "-" +
                    (dataReport.finalDate.getMonth() + 1) + "-" +
                    dataReport.finalDate.getDate(),
                chkGarantia: dataReport.guaranteeCheck,
                chkISIN: dataReport.isin,
            }
        }).then(res => res.data);
    }

    getConcentratedPositionReport(dataReport) {
        return axios.get('/appapv/getConcentratedPositionReport.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                fechaInicial: dataReport.startDate.getFullYear() + "-" +
                    (dataReport.startDate.getMonth() + 1) + "-" +
                    dataReport.startDate.getDate(),
                fechaFinal: dataReport.finalDate.getFullYear() + "-" +
                    (dataReport.finalDate.getMonth() + 1) + "-" +
                    dataReport.finalDate.getDate(),
                chkDetalle: true,
            }
        }).then(res => res.data);
    }

    getMarketActiveReport(dataReport) {
        return axios.get('/appapv/getMarketActiveReport.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                fechaInicial: dataReport.startDate.getFullYear() + "-" +
                    (dataReport.startDate.getMonth() + 1) + "-" +
                    dataReport.startDate.getDate(),
                fechaFinal: dataReport.finalDate.getFullYear() + "-" +
                    (dataReport.finalDate.getMonth() + 1) + "-" +
                    dataReport.finalDate.getDate(),
            }
        }).then(res => res.data);
    }

    getEmailConfirmation(rol, folio) {
        return axios.get('/appapv/getContactEmailRol.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                rolPrestamo: rol ? rol : '',
                folioPrestamo: folio ? folio : '',
            }
        }).then(res => res.data);
    }

    sendHistoricalReport(emailList, folio) {
        return axios.post('/appapv/sendHistoricalReport.action', {}, {
            params: {
                correo: emailList ? emailList : '',
                folioPrestamo: folio,
            }
        }).then(res => res.data);
    }

    getDailyActiveReport(reportType, rol, fecValor) {
        return axios.get('/appapv/getDailyActiveReport.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                tipoReporte: reportType,
                rol: rol,
                fecValor: fecValor ? 1 : 0,
            }
        }).then(res => res.data);
    }

    getIntradayReport(consultDate, institucionId, withGuarantee) {
        return axios.get('/reports/intradayLoan', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                consultDate: consultDate,
                institucionId: institucionId,
                withGuarantee: withGuarantee,
            }
        }).then(res => res.data);
    }

    getEventsReport() {
        return axios.get('/scotia/event/loans/events', {

            headers: {
                'Content-Type': 'application/json',
            },
            params: {}
        }).then(res => res.data);
    }

    getIntradayReportCSV(params) {
        return downloadFile('/reports/intradayLoanCsv', params);
    }

    getIntradayReportPdf(params) {
        return downloadFile('/reports/intradayLoanPdf', params);
    }

    getIntradayReportXls(params) {
        return downloadFile('/reports/intradayLoanXls', params);
    }

    getHistoricalReportCSV(params) {
        return downloadFileServlet('/appapv/ApvSrvControlador', params);
    }

    getHistoricalReportPDF(params) {
        return downloadFile('/appapv/getHistoricalReportPDF.action', params);
    }

    getHistoricalReportXLS(params) {
        return downloadFile('/appapv/getHistoricalReportXLS.action', params);
    }

    getStartProrrogaReport(params) {
        return downloadFile('/appapv/getStartProrrogaReport.action', params);
    }

    getPositionReportPDF(params) {
        return downloadFile('/appapv/getPositionReportPDF.action', params)
    }

    getPositionReportXLS(params) {
        return downloadFile('/appapv/getPositionReportXLS.action', params)
    }

    getActiveMarketReportPDF(params) {
        return downloadFile('/appapv/getActiveMarketReportPDF.action', params)
    }

    getActiveMarketReportXLS(params) {
        return downloadFile('/appapv/getActiveMarketReportXLS.action', params)
    }

    getDailyReportPDF(params) {
        return downloadFile('/appapv/getDailyReportPDF.action', params)
    }

    getDailyReportXLS(params) {
        return downloadFile('/appapv/getDailyReportXLS.action', params)
    }

    getEventsReportCSV(params) {
        return downloadFile('/scotia/event/loans/events/csv-format', params);
    }

    getInstructionsReportCSV(params) {
        return downloadFile('/fiduciario/instruction/contingency/csv-format', params);
    }

    getIntraInstitutionalReportCSV(params) {
        return downloadFile('/appapv/getIntraInstitutionFinamex.action', params);
    }

    getAladdinReportCSV(params) {
        let report = params.valueAladdinReport;
        let urlAction = {
            "inicioPrestamos": '/appapv/getLoanPactToday.action',
            "garantiasES": '/appapv/getCollateralMovementToday.action',
            "restricciones": '/appapv/getInstrumentLoanSummary.action'
        }[report] || "";

        return axios.get(urlAction, {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {}
        }).then(res => res.data);
    }
}